import { render } from "./ActionButton.vue?vue&type=template&id=772c7360&scoped=true"
import script from "./ActionButton.vue?vue&type=script&lang=js"
export * from "./ActionButton.vue?vue&type=script&lang=js"

import "./ActionButton.vue?vue&type=style&index=0&id=772c7360&scoped=true&lang=css"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772c7360"]])

export default __exports__